<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6157_191271)">
      <path d="M3.33301 33.334H36.6663V36.6673H3.33301V33.334ZM6.66634 20.0007H9.99967V31.6673H6.66634V20.0007ZM14.9997 20.0007H18.333V31.6673H14.9997V20.0007ZM21.6663 20.0007H24.9997V31.6673H21.6663V20.0007ZM29.9997 20.0007H33.333V31.6673H29.9997V20.0007ZM3.33301 11.6673L19.9997 3.33398L36.6663 11.6673V18.334H3.33301V11.6673ZM19.9997 13.334C20.4417 13.334 20.8656 13.1584 21.1782 12.8458C21.4907 12.5333 21.6663 12.1093 21.6663 11.6673C21.6663 11.2253 21.4907 10.8014 21.1782 10.4888C20.8656 10.1762 20.4417 10.0007 19.9997 10.0007C19.5576 10.0007 19.1337 10.1762 18.8212 10.4888C18.5086 10.8014 18.333 11.2253 18.333 11.6673C18.333 12.1093 18.5086 12.5333 18.8212 12.8458C19.1337 13.1584 19.5576 13.334 19.9997 13.334V13.334Z" fill="url(#paint0_linear_6157_191271)" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_6157_191271" x1="-1.97265" y1="-24.6753" x2="52.9636" y2="-14.7236" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <clipPath id="clip0_6157_191271">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
